import { formatDate } from '@angular/common';

const EVENT_DATETIME_PLACEHOLDER = '{event_datetime}';

/**
 * The backend writes the event time into a push body as UTC text. It also sends the body with a
 * placeholder where the time goes and the time itself as an ISO timestamp, so the browser can show
 * it in the user's timezone, in the same format as the notification panel header.
 * Falls back to the plain body when the template or timestamp is missing or invalid.
 */
export function renderNotificationBody(
  body: string,
  bodyTemplate?: string | null,
  eventDatetime?: string | null,
): string {
  if (!bodyTemplate || !eventDatetime || !bodyTemplate.includes(EVENT_DATETIME_PLACEHOLDER)) return body;
  if (Number.isNaN(Date.parse(eventDatetime))) return body;
  return bodyTemplate.replace(EVENT_DATETIME_PLACEHOLDER, formatDate(eventDatetime, 'M/d/yyyy h:mm a', 'en-US'));
}
